<template>
  <div class="machine-list">
    <add-machine
      :addOrEdit="addOrEdit"
      :machine="machine"
      :dialogMachine="dialogMachine"
      :machineType="machineType"
      :machineGroup="machineGroup"
      :appTypeList="appTypeList"
      :machineVersion="machineVersion"
      v-on:cancel="cancel"
    >
    </add-machine>
    <!-- :appVersion="appVersion" -->
    <search-machine
      :search="search"
      :yesNo="yesNo"
      :appTypeList="appTypeList"
      :multipleSelection="multipleSelection"
      :machineType="machineType"
      :machineGroup="machineGroup"
      v-on:importSuccess="importSuccess"
      v-on:addMachine="addMachine"
      v-on:recoverMachine="recoverMachine"
      v-on:onSubmit="onSubmit"
      v-on:resetSearch="resetSearch"
    >
    </search-machine>
    <div class="user-main vue-padding">
      <el-table
        v-loading="loading"
        ref="machineTable"
        :empty-text="$t('common.noData')"
        :element-loading-text="$t('common.loading')"
        :data="machineList"
        @selection-change="handleSelectionChange"
        style="width: 100%"
        max-height="638"
        :border="true"
      >
        <el-table-column type="selection" :selectable="selectable" width="40" :align="'center'"></el-table-column>
        <el-table-column prop="mqState" :label="$t('machineUser.online')" width="65" :align="'center'">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.mqState && scope.row.mqState == 0"
              style="width: 10px; height: 10px"
              :src="require('_as/zaixian.png')"
              fit="fill"
            ></el-image>
            <el-image
              v-if="scope.row.mqState && scope.row.mqState == 1"
              style="width: 10px; height: 10px"
              :src="require('_as/lixian.png')"
              fit="fill"
            ></el-image>
            <div
              v-if="!scope.row.mqState"
              style="
                width: 10px;
                height: 10px;
                background-color: #dcdfe6;
                border-radius: 100%;
                margin: 0 auto;
                border: 2px solid #909399;
              "
            ></div>
          </template>
        </el-table-column>
        <el-table-column
          prop="teamName"
          :show-overflow-tooltip="true"
          :label="$t('machine.teamName')"
          width="130"
          :align="'center'"
        ></el-table-column>
        <el-table-column prop="userName" :label="$t('admin.Machine.476040-0')" width="180" :align="'center'">
          <template #default="scope">
            {{ scope.row.userName ? scope.row.userName : "Unallocated" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="typeName"
          :label="$t('machine.typeName')"
          width="155"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          prop="equipmentNo"
          :label="$t('machine.equipmentNo')"
          width="140"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          prop="equipmentName"
          :label="$t('machine.name')"
          width="170"
          :align="'center'"
        ></el-table-column>
        <!-- <el-table-column
					prop="apkVersion"
					:label="$t('machine.appVersionName')"
					width="110"
					:align="'center'"
				></el-table-column> -->

        <el-table-column
          prop="notes"
          :show-overflow-tooltip="true"
          :label="$t('machine.notes')"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          :label="$t('machine.createTime')"
          :align="'center'"
          width="170px"
        ></el-table-column>
        <el-table-column
          fixed="right"
          :label="$t('common.operate')"
          :align="'center'"
          :width="$i18n.locale == 'zh_CN' ? 155 : 155"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.sell === 0">
              <el-button size="mini" v-hasPerm="['machine:update']" @click="editMachine(scope.row)">{{
                $t("common.edit")
              }}</el-button>
              <el-button type="danger" v-hasPerm="['machine:delete']" size="mini" @click="delMachine(scope.row)">{{
                $t("common.delete")
              }}</el-button>
            </span>
            <span v-else>
              <el-tag type="success">{{ $t("machine.sold") }}</el-tag>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="machineList.length > 0"
        background
        layout="total,sizes,prev, pager, next,jumper"
        :current-page="page.pageIndex"
        :total="page.totalSize"
        :page-size="page.pageSize"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
  import addMachine from "_c/machine/admin/AddMachine";
  import searchMachine from "_c/machine/admin/SearchMachine";
  export default {
    name: "MachineList",
    components: {
      addMachine,
      searchMachine
    },
    data() {
      return {
        loading: false,
        machineList: [],
        machine: {
          apkId: "",
          teamId: "",
          typeId: "",
          equipmentNo: "",
          appVersion: "",
          equipmentName: "",
          notes: ""
        },
        page: {
          pageSize: 10,
          pageIndex: 1
        },
        search: {
          teamId: "",
          typeId: "",
          equipmentNo: "",
          sell: "",
          equipmentName: ""
        },
        multipleSelection: [],
        machineTypeList: [],
        appTypeList: [],
        yesNo: [],
        dialogMachine: false,
        addOrEdit: false,
        machineType: [],
        machineGroup: [],
        // appVersion: [],
        machineVersion: []
      };
    },
    mounted() {
      this.currentChange();
      this.listMachineTypeList();
      this.listAppType();
      this.listMachineType();
      this.listMachineGroup();
      // this.listAppVersion();
      this.listMachineVersion();
    },
    methods: {
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      selectable(row) {
        return row.sell !== 0;
      },
      listMachineTypeList() {
        this.$api.dict("sys_yes_no").then(res => {
          if (res.code === 0) {
            this.yesNo = res.data;
          }
        });
      },
      listAppType() {
        this.$api.dict("sys_app_type").then(res => {
          if (res.code === 0) {
            this.appTypeList = res.data;
          }
        });
      },
      listMachineType() {
        this.$api.request(this.$url.MachineType.list, this.$method.get).then(res => {
          if (res.code === 0) {
            this.machineType = res.data;
          }
        });
      },
      listMachineGroup() {
        this.$api.request(this.$url.MachineGroup.list, this.$method.get).then(res => {
          if (res.code === 0) {
            this.machineGroup = res.data;
          }
        });
      },
      // listAppVersion() {
      // 	this.$api
      // 		.request(this.$url.AppVersion.listAppVersion, this.$method.get, {
      // 			type: 1,
      // 		})
      // 		.then(res => {
      // 			if (res.code === 0) {
      // 				this.appVersion = res.data;
      // 			}
      // 		});
      // },
      listMachineVersion() {
        this.$api.dict("machine_version").then(res => {
          if (res.code === 0) {
            this.machineVersion = res.data;
          }
        });
      },

      appType(row) {
        return this.$cloud.getDictLabel(this.appTypeList, row.appType);
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
        this.currentChange();
      },
      currentChange(pageIndex) {
        this.loading = true;
        this.page.pageIndex = pageIndex ? pageIndex : 1;
        let obj = this.$cloud.objMerge(this.search, this.page);
        this.$api
          .request(this.$url.Machine.page, this.$method.get, obj)
          .then(res => {
            if (res.code === 0) {
              this.machineList = res.data.records;
              this.page.totalSize = parseInt(res.data.total);
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      },
      addMachine() {
        this.dialogMachine = true;
        this.addOrEdit = true;
      },
      importSuccess(result) {
        if (result.success > 0) {
          this.currentChange();
        }
      },
      // 回收设备
      recoverMachine() {
        this.$confirm(this.$t("machine.recycle"), this.$t("common.tip"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        }).then(() => {
          this.$api
            .request(this.$url.Machine.recover, this.$method.put, {
              ids: this.$cloud.getIds(this.multipleSelection)
            })
            .then(res => {
              if (res.code === 0) {
                this.$notify({
                  title: this.$t("common.tip"),
                  message: res.msg,
                  type: "success"
                });
                this.currentChange();
              }
            });
        });
      },
      onSubmit(data) {
        this.search = data;
        this.currentChange();
      },
      resetSearch(data) {
        this.search = data;
        this.currentChange();
      },
      cancel(dialog, state) {
        this.dialogMachine = dialog;
        if (state) {
          this.currentChange(this.page.pageIndex);
        }
      },
      // 编辑设备
      editMachine(row) {
        this.dialogMachine = true;
        this.addOrEdit = false;
        Object.keys(this.machine).forEach(key => {
          this.machine[key] = row[key];
        });
        this.machine.id = row.id;
      },
      // 删除设备
      delMachine(row) {
        this.$confirm(this.$t("machine.delete"), this.$t("common.tip"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        }).then(() => {
          this.$api
            .request(this.$url.Machine.delete, this.$method.delete, {
              id: row.id
            })
            .then(res => {
              if (res.code === 0) {
                this.$notify({
                  title: this.$t("common.tip"),
                  message: this.$t("machine.deleteS"),
                  type: "success"
                });
                this.currentChange();
              }
            });
        });
      }
    }
  };
</script>

<style scoped></style>
